export default __webpack_public_path__ + "static/media/menu.271ea0c1.svg";